import React from "react"
import { Bookmark } from "lucide-react"
import "./BookmarksHeader.style.scss"

interface BookmarksHeaderProps {
  savedCount: number
}

const BookmarksHeader = ({ savedCount }: BookmarksHeaderProps) => (
  <header className="bookmarks-header">
    <div className="bookmarks-header__icon">
      <Bookmark size={20} />
    </div>
    <div>
      <h1>Bookmarks</h1>
      <p>Review your saved questions and topics</p>
    </div>
    {savedCount > 0 && (
      <span className="bookmarks-header__count">
        {savedCount} saved
      </span>
    )}
  </header>
)

export default BookmarksHeader
